
jQuery(document).ready(function() {
    var $body = jQuery('body')
	
    if( $body.hasClass('home') ) {

        function getpagephotos_load_posts(){
			var str_getpagephotos = '&action=page_photos_ajax';
			jQuery.ajax({
				type: "POST",
				dataType: "html",
				url: ajax_posts.ajaxurl,
				data: str_getpagephotos,
				success: function(data){
					//console.log('funciona');
					var $data_getpagephotos = jQuery(data);
					if(jQuery("#photos").length == 0){

						if(jQuery("#content").hasClass("active-getclose")){
							jQuery("#content").removeClass("active-getclose");
							jQuery("#content").addClass("active-photos");
                            setTimeout(function() {
								//jQuery("#content.active-getclose").animate({height: '0'}, 1000);
								jQuery("#content span.transition").animate({height: '0'}, 500);
								jQuery("#content span.transition").animate({opacity: 1}, 1000);
								jQuery(".section-feat-video").animate({opacity: 0}, 500);
								//jQuery(".section-feat-video .overlay, .section-feat-video img").animate({height: '0'}, 1000);
							}, 500);

                            setTimeout(function() {
								jQuery( "#content section" ).not(this).remove();
								jQuery('#content').append($data_getpagephotos);

								jQuery("#content.active-photos").animate({height: '100%'}, 500);
								jQuery("#content span.transition").animate({height: '100%'}, 800);
								jQuery("#content span.transition").animate({opacity: 0}, 1000);

                                jQuery(".section-photos").delay(200).animate({opacity: 1}, 1000);
							}, 2500);
							
						}else if(jQuery("#content").hasClass("active-videos")){

                            jQuery("#content").removeClass("active-videos");
							jQuery("#content").addClass("active-photos");
							setTimeout(function() {
								//jQuery("#content.active-videos").animate({height: '0'}, 1000);
								jQuery("#content span.transition").animate({height: '0'}, 1000);
								jQuery("#content span.transition").animate({opacity: 1}, 500);
								jQuery("#videos").animate({opacity: 0}, 500);
							}, 500);

                            setTimeout(function() {
								jQuery( "#content section" ).not(this).remove();
								jQuery('#content').append($data_getpagephotos);

								jQuery("#content.active-photos").animate({height: '100%'}, 500);
								jQuery("#content span.transition").animate({height: '100%'}, 800);
								jQuery("#content span.transition").animate({opacity: 0}, 1000);

                                jQuery(".section-photos").delay(200).animate({opacity: 1}, 1000);
							}, 2500);

						}else if(jQuery("#content").hasClass("active-music")){
                            jQuery("#content").removeClass("active-music");
                            jQuery("#content").addClass("active-photos");

                            setTimeout(function() {
								jQuery("#content").animate({height: '0'}, 1000);
								jQuery("#content span.transition").animate({height: '0'}, 1000);
								jQuery("#content span.transition").animate({opacity: 1}, 500);
								jQuery("#music").animate({opacity: 0}, 500);
							}, 500);

                            setTimeout(function() {
								jQuery( "#content section" ).not(this).remove();
								jQuery('#content').append($data_getpagephotos);

								jQuery( "body" ).removeClass( "middle-header" );
								jQuery( "body" ).addClass( "top-header" );

								jQuery("#content.active-photos").animate({height: '100%'}, 500);
								jQuery("#content span.transition").animate({height: '100%'}, 800);
								jQuery("#content span.transition").animate({opacity: 0}, 1000);

                                jQuery(".section-photos").delay(200).animate({opacity: 1}, 1000);
							}, 2500);

						}else if(jQuery("#content").hasClass("active-tour")){
                            jQuery("#content").removeClass("active-tour");
                            jQuery("#content").addClass("active-photos");

                            setTimeout(function() {
								jQuery("#content").animate({height: '0'}, 1000);
								jQuery("#content span.transition").animate({height: '0'}, 1000);
								jQuery("#content span.transition").animate({opacity: 1}, 500);
								jQuery("#tour").animate({opacity: 0}, 500);
							}, 500);

                            setTimeout(function() {
								jQuery( "#content section" ).not(this).remove();
								jQuery('#content').append($data_getpagephotos);

								jQuery( "body" ).removeClass( "middle-header" );
								jQuery( "body" ).addClass( "top-header" );

								jQuery("#content.active-photos").animate({height: '100%'}, 500);
								jQuery("#content span.transition").animate({height: '100%'}, 800);
								jQuery("#content span.transition").animate({opacity: 0}, 1000);

                                jQuery(".section-photos").delay(200).animate({opacity: 1}, 1000);
							}, 2500);

						}else{
							jQuery("#content").addClass("active-photos");
							setTimeout(function() {

								jQuery( "#content section" ).not(this).remove();
								jQuery('#content').append($data_getpagephotos);

								jQuery( "body" ).removeClass( "middle-header" );
								jQuery( "body" ).addClass( "top-header" );

								jQuery("#content.active-photos").animate({height: '100%'}, 500);
								jQuery("#content span.transition").animate({height: '100%'}, 800);
								jQuery("#content span.transition").animate({opacity: 0}, 1000);

                                jQuery(".section-photos").delay(200).animate({opacity: 1}, 1000);

							}, 500);
						}
					}
				},
				error : function(jqXHR, textStatus, errorThrown) {
					//console.log('error');
					jQuery('.message-error').html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
				}

			});
			return false;
		}

		jQuery(".nav-photos a").on("click",function(e){ // When btn is pressed.
			jQuery(".js-off-canvas-overlay").trigger( "click" );
			getpagephotos_load_posts();
		});

    }

});
